import cx from 'classnames';
import PropTypes from 'prop-types';

import { CUSTOM_BUTTON_COLOR, CustomButton } from 'src/components/CustomButton';
import { DetectedViolation, DetectedViolationSkeleton } from 'src/components/DetectedViolation';

import { InsightBox } from '../../../InsightBox';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  violations: PropTypes.arrayOf(
    PropTypes.shape({
      explanation: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
  onFixAllClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  readOnly: PropTypes.bool,
};

const defaultProps = {
  className: null,
  loading: false,
  readOnly: false,
};

export const StyleGuideItem = ({ className, violations, onFixAllClick, loading, readOnly }) => {
  const styles = useStyles();

  if (!violations.length) {
    return null;
  }

  return (
    <InsightBox
      className={cx(styles.root, className)}
      classes={{ title: styles.title }}
    >
      {loading ? (
        <DetectedViolationSkeleton />
      ) : (
        <>
          {violations.map((detectedViolation, index) => (
            <DetectedViolation
              className={styles.detectedViolation}
              key={index}
              detectedViolation={detectedViolation}
            />
          ))}

          {!readOnly && (
            <CustomButton
              className={styles.button}
              color={CUSTOM_BUTTON_COLOR.silver}
              onClick={onFixAllClick}
            >
              Fix all
            </CustomButton>
          )}
        </>
      )}
    </InsightBox>
  );
};

StyleGuideItem.propTypes = propTypes;
StyleGuideItem.defaultProps = defaultProps;
